export default {
      id: "icon-message-usage",
      viewBox: "0 0 12 12",
      url: __webpack_public_path__ + "assets/template/sprite/sprite.svg#icon-message",
      toString: function () {
        return this.url;
      }
    }